import { SectionItem } from '@app/shell/SiteHeader/shared/types/MobileMenuSection';

const SNEAKERS = {
  title: 'Sneakers',
  link: 'sneakers',
  submenu: [
    {
      title: 'Adidas',
      urlKey: 'adidas',
    },
    {
      title: 'Air Jordan',
      urlKey: 'retro-jordans',
    },
    {
      title: 'Yeezy',
      urlKey: 'yeezy',
    },
    {
      title: 'Nike',
      urlKey: 'nike',
    },
    {
      title: 'New Balance',
      urlKey: 'new-balance',
    },
    {
      title: 'Reebok',
      urlKey: 'reebok',
    },
    {
      title: 'Converse',
      urlKey: 'converse',
    },
    {
      title: 'Puma',
      urlKey: 'puma',
    },
    {
      title: 'Collections',
      urlKey: 'collections',
    },
    {
      title: 'Luxury Brands',
      urlKey: 'luxury-brands',
    },
    {
      title: 'Other Brands',
      urlKey: 'other-sneakers',
    },
    {
      title: 'Vans',
      urlKey: 'vans',
    },
    {
      title: 'Releases',
      urlKey: 'new-releases/sneakers',
    },
  ],
};

const SHOES = {
  title: 'Shoes',
  link: 'shoes',
  submenu: [
    {
      title: 'Birkenstock',
      urlKey: 'birkenstock',
    },
    {
      title: 'Chanel',
      urlKey: 'chanel-shoes',
    },
    {
      title: 'Christian Louboutin',
      urlKey: 'christian-louboutin',
    },
    {
      title: 'Clarks',
      urlKey: 'clarks',
    },
    {
      title: 'Crocs',
      urlKey: 'crocs',
    },
    {
      title: 'Dr. Martens',
      urlKey: 'dr-martens',
    },
    {
      title: 'Hermes',
      urlKey: 'hermes-shoes',
    },
    {
      title: 'Gucci',
      urlKey: 'gucci-shoes',
    },
    {
      title: 'Timberland',
      urlKey: 'timberland',
    },
    {
      title: 'UGG',
      urlKey: 'ugg',
    },
  ],
};

const APPAREL = {
  title: 'Apparel',
  link: 'apparel',
  submenu: [
    {
      title: 'Adidas Apparel',
      urlKey: 'adidas-apparel',
    },
    {
      title: 'Artist Merch',
      urlKey: 'artist-merch',
    },
    {
      title: 'Chrome Hearts',
      urlKey: 'chrome-hearts',
    },
    {
      title: 'Comme des Garçons Play',
      urlKey: 'comme-des-garcons-play',
    },
    {
      title: 'Drew House',
      urlKey: 'drew-house',
    },
    {
      title: 'Eric Emanuel',
      urlKey: 'eric-emanuel',
    },
    {
      title: 'Essentials',
      urlKey: 'fear-of-god-essentials',
    },
    {
      title: 'Fear of God',
      urlKey: 'fear-of-god',
    },
    {
      title: 'Gallery Dept.',
      urlKey: 'gallery-dept',
    },
    {
      title: 'Gucci',
      urlKey: 'gucci-apparel',
    },
    {
      title: 'KAWS',
      urlKey: 'kaws-apparel',
    },
    {
      title: 'Kith',
      urlKey: 'kith',
    },
    {
      title: 'Moncler',
      urlKey: 'moncler',
    },
    {
      title: 'Nike Apparel',
      urlKey: 'nike-apparel',
    },
    {
      title: 'Off-White',
      urlKey: 'off-white',
    },
    {
      title: 'Palace',
      urlKey: 'palace',
    },
    {
      title: 'Palm Angels',
      urlKey: 'palm-angels',
    },
    {
      title: 'Sp5der',
      urlKey: 'sp5der',
    },
    {
      title: 'Stussy',
      urlKey: 'stussy',
    },
    {
      title: 'Supreme',
      urlKey: 'supreme',
    },
    {
      title: 'The North Face',
      urlKey: 'the-north-face',
    },
    {
      title: 'Vlone',
      urlKey: 'vlone',
    },
    {
      title: 'Yeezy Gap',
      urlKey: 'yeezy-gap',
    },
    {
      title: 'Other Brands',
      urlKey: 'other-apparel',
    },
  ],
};

const ELECTRONICS = {
  title: 'Electronics',
  link: 'electronics',
  submenu: [
    {
      title: 'Certified Refurbished',
      urlKey: 'certified-refurbished',
    },
    {
      title: 'Apple',
      urlKey: 'apple',
    },
    {
      title: 'AMD',
      urlKey: 'amd',
    },
    {
      title: 'Beats',
      urlKey: 'beats',
    },
    {
      title: 'Bose',
      urlKey: 'bose',
    },
    {
      title: 'Computer Components',
      urlKey: 'computer-components',
    },
    {
      title: 'Cameras',
      urlKey: 'cameras',
    },
    {
      title: 'Dyson',
      urlKey: 'dyson',
    },
    {
      title: 'Finalmouse',
      urlKey: 'finalmouse',
    },
    {
      title: 'Gaming Laptops',
      urlKey: 'gaming-laptops',
    },
    {
      title: 'JBL',
      urlKey: 'jbl',
    },
    {
      title: 'Logitech',
      urlKey: 'logitech',
    },
    {
      title: 'Intel',
      urlKey: 'intel',
    },
    {
      title: 'Microsoft',
      urlKey: 'microsoft',
    },
    {
      title: 'Nvidia',
      urlKey: 'nvidia',
    },
    {
      title: 'Nintendo',
      urlKey: 'nintendo',
    },
    {
      title: 'Oculus',
      urlKey: 'oculus',
    },
    {
      title: 'Playstation',
      urlKey: 'playstation',
    },
    {
      title: 'Razer',
      urlKey: 'razer',
    },
    {
      title: 'Samsung',
      urlKey: 'samsung',
    },
    {
      title: 'Video Games',
      urlKey: 'video-games',
    },
    {
      title: 'Valve Steam Deck',
      urlKey: 'valve-steam-deck',
    },
    {
      title: 'Virtual Reality',
      urlKey: 'virtual-reality',
    },
    {
      title: 'Xbox',
      urlKey: 'xbox',
    },
    {
      title: 'Other Electronics',
      urlKey: 'other-electronics',
    },
  ],
};

const TRADING_CARDS = {
  title: 'Trading Cards',
  link: 'trading-cards',
  submenu: [
    {
      title: 'Baseball',
      urlKey: 'baseball',
    },
    {
      title: 'Basketball',
      urlKey: 'basketball-cards',
    },
    {
      title: 'Football',
      urlKey: 'football-cards',
    },
    {
      title: 'Hockey',
      urlKey: 'hockey',
    },
    {
      title: 'Soccer',
      urlKey: 'soccer-cards',
    },
    {
      title: 'Sealed Boxes',
      urlKey: 'sealed-boxes',
    },
    {
      title: 'Pokémon',
      urlKey: 'pokemon-cards',
    },
    {
      title: 'YU-GI-OH!',
      urlKey: 'yu-gi-oh-tcg',
    },
    {
      title: 'Magic the Gathering',
      urlKey: '/magic-the-gathering',
    },
    {
      title: 'Other Sports',
      urlKey: 'trading-cards',
    },
    {
      title: 'Other TCG',
      urlKey: 'other-tcg',
    },
  ],
};

const COLLECTIBLES = {
  title: 'Collectibles',
  link: 'collectibles',
  submenu: [
    {
      title: 'KAWS',
      urlKey: 'kaws',
    },
    {
      title: 'Bearbrick',
      urlKey: 'bearbrick',
    },
    {
      title: 'Art Prints',
      urlKey: 'art-prints',
    },
    {
      title: 'Lego',
      urlKey: 'lego',
    },
    {
      title: 'Funko POP!',
      urlKey: 'funko-pop',
    },
    {
      title: 'Action Figures',
      urlKey: 'action-figures',
    },
    {
      title: 'Daniel Arsham',
      urlKey: 'daniel-arsham',
    },
    {
      title: 'Takashi Murakami',
      urlKey: 'takashi-murakami-collectibles',
    },
    {
      title: 'Virgil Abloh',
      urlKey: 'virgil-abloh',
    },
    {
      title: 'Skate Decks',
      urlKey: 'skate-decks',
    },
    {
      title: 'Comic Books',
      urlKey: 'comic-books',
    },
    {
      title: 'Other Artists',
      urlKey: 'other-artists',
    },
    {
      title: 'Other Collectibles',
      urlKey: 'other-collectibles',
    },
  ],
};

const ACCESSORIES = {
  title: 'Accessories',
  link: 'accessories',
  submenu: [
    {
      title: 'Swatch x Omega',
      urlKey: 'swatch-x-omega',
    },
    {
      title: 'Balenciaga',
      urlKey: 'balenciaga',
    },
    {
      title: 'Bape',
      urlKey: 'bape-accessories',
    },
    {
      title: 'Burberry',
      urlKey: 'burberry',
    },
    {
      title: 'Casio',
      urlKey: 'casio-g-shock',
    },
    {
      title: 'Chanel',
      urlKey: 'chanel',
    },
    {
      title: 'Chrome Hearts',
      urlKey: 'chrome-hearts-accessories',
    },
    {
      title: 'Coach',
      urlKey: 'coach',
    },
    {
      title: 'Dior',
      urlKey: 'dior-accessories',
    },
    {
      title: 'Fear of God',
      urlKey: 'fear-of-god-accessories',
    },
    {
      title: 'Goyard',
      urlKey: 'goyard',
    },
    {
      title: 'Gucci',
      urlKey: 'gucci',
    },
    {
      title: 'Kith',
      urlKey: 'kith-accessories',
    },
    {
      title: 'Louis Vuitton',
      urlKey: 'louis-vuitton',
    },
    {
      title: 'New Era',
      urlKey: 'new-era',
    },
    {
      title: 'Nike',
      urlKey: 'nike-accessories',
    },
    {
      title: 'Off-White',
      urlKey: 'off-white-accessories',
    },
    {
      title: 'Prada',
      urlKey: 'prada',
    },
    {
      title: 'Rolex',
      urlKey: 'rolex',
    },
    {
      title: 'Saint Luarent',
      urlKey: 'saint-laurent',
    },
    {
      title: 'Supreme',
      urlKey: 'supreme-accessories',
    },
    {
      title: 'Telfar',
      urlKey: 'telfar',
    },
    {
      title: 'Other Brands',
      urlKey: 'other-accessories',
    },
  ],
};

const TRENDING_DEALS = {
  title: 'Trending Deals',
  link: 'sneakers?trending_deals=true',
};

export const SECTION_BROWSE: SectionItem = {
  title: 'Browse',
  subTitle: 'Browse All',
  subTitleLink: 'sneakers',
  subsections: [
    SNEAKERS,
    SHOES,
    APPAREL,
    ELECTRONICS,
    TRADING_CARDS,
    COLLECTIBLES,
    ACCESSORIES,
    TRENDING_DEALS,
  ],
};

export const SECTION_ABOUT: SectionItem = {
  title: 'About',
  submenu: [
    {
      title: 'How It Works',
      urlKey: 'about/how-it-works',
    },
    {
      title: 'Buying Guide',
      urlKey: 'about/buying',
    },
    {
      title: 'Selling Guide',
      urlKey: 'about/selling',
    },
    {
      title: 'Authentication',
      urlKey: 'about/authentication',
    },
    {
      title: 'Newsroom',
      urlKey: 'about/newsroom',
    },
    {
      title: 'Company',
      urlKey: 'about/company',
    },
  ],
  blogIgnore: true,
};
export const SECTION_ABOUT_EXTERNAL: SectionItem = {
  title: 'About',
  outBoundUrl: 'https://stockx.com/about/company',
  onlyForBlog: true,
};

export const SECTION_HOW_IT_WORKS: SectionItem = {
  title: 'How It Works',
  outBoundUrl: 'https://stockx.com/about/how-it-works',
  blogIgnore: false,
};

export const SECTION_NEW_RELEASES: SectionItem = {
  title: 'New Releases',
  urlKey: 'new-releases',
};

export const SECTION_POPULAR_BRANDS: SectionItem = {
  title: 'Popular Brands',
  link: 'sneakers',
  blogIgnore: true,
  submenu: [
    {
      title: 'Air Jordan',
      urlKey: 'retro-jordans',
    },
    {
      title: 'Nike',
      urlKey: 'nike',
    },
    {
      title: 'Adidas',
      urlKey: 'adidas',
    },
    {
      title: 'Yeezy',
      urlKey: 'yeezy',
    },
    {
      title: 'Supreme',
      urlKey: 'supreme',
    },
    {
      title: 'Bape',
      urlKey: 'bape',
    },
    {
      title: 'Kith',
      urlKey: 'kith',
    },
    {
      title: 'Palace',
      urlKey: 'palace',
    },
    {
      title: 'Apple',
      urlKey: 'electronics/apple-collectibles',
    },
    {
      title: 'Playstation',
      urlKey: 'electronics/playstation',
    },
    {
      title: 'Xbox',
      urlKey: 'electronics/xbox',
    },
    {
      title: 'Nvidia',
      urlKey: 'electronics/nvidia',
    },
    {
      title: 'Nintendo',
      urlKey: 'electronics/nintendo',
    },
    {
      title: 'KAWS',
      urlKey: 'kaws',
    },
    {
      title: 'Bearbrick',
      urlKey: 'bearbrick',
    },
    {
      title: 'Takashi Murakami',
      urlKey: 'takashi-murakami',
    },
    {
      title: 'Pokemon',
      urlKey: 'trading-cards/pokemon',
    },
    {
      title: 'Magic the Gathering',
      urlKey: 'trading-cards/magic-the-gathering',
    },
    {
      title: 'Rolex',
      urlKey: 'rolex',
    },
    {
      title: 'Omega',
      urlKey: 'omega',
    },
    {
      title: 'Cartier',
      urlKey: 'cartier',
    },
    {
      title: 'Casio',
      urlKey: 'casio',
    },
    {
      title: 'Louis Vuitton',
      urlKey: 'louis-vuitton',
    },
    {
      title: 'Gucci',
      urlKey: 'gucci',
    },
    {
      title: 'Chanel',
      urlKey: 'chanel',
    },
    {
      title: 'MCM',
      urlKey: 'mcm',
    },
    {
      title: 'Browse All',
      decorate: true,
      urlKey: 'sneakers',
    },
  ],
};

export const SECTION_NEWS: SectionItem = {
  title: 'News',
  outBoundUrl: 'https://stockx.com/news',
  blogIgnore: true,
};

export const SECTION_MY_ACCOUNT: SectionItem = {
  title: 'My Account',
  urlKey: 'profile',
  submenu: [
    {
      title: 'security_header',
      urlKey: 'security',
    },
    {
      title: 'Buying',
      urlKey: 'buying',
    },
    {
      title: 'Selling',
      urlKey: 'selling',
    },
    {
      title: 'My Portfolio',
      urlKey: 'portfolio',
    },
    {
      title: 'Following',
      urlKey: 'following',
    },
    {
      title: 'Profile',
      urlKey: 'profile',
    },
    {
      title: 'Settings',
      urlKey: 'settings',
    },
    {
      title: 'Sign Out',
      urlKey: 'signout',
    },
  ],
};
